import React from 'react'

import lang from '../../../../../../languages/en'
import { convertDateFromUTC } from '../../../../../../services/dst'
import { getImageChannel } from '../../../../../../constants/order'

import styles from './styles.css'

const getTypeError = {
    "Error": "FATAL",
    "FATAL": "FATAL"
}
class Step3 extends React.Component {
    renderRow = () => {
        const { dataImport } = this.props
        return (
            <tr className="fatal-error">
                <td className="col-te">{convertDateFromUTC(dataImport.importDateTime).format("MM/DD/YYYY HH:mm")}</td>
                <td className="col-te">{getImageChannel(dataImport.channel)}</td>
                <td className="col-te">{dataImport.addedItems}</td>
                <td className="col-te">{dataImport.updatedItems}</td>
                <td className="col-te">{dataImport.deletedItems}</td>
                <td className="col-te" style={{ color: 'red' }}>{dataImport.errorCount}</td>
            </tr>
        )
    }

    renderRowChildren = () => {
        return this.props.dataImport.importResultDetails.map((e, i) => {
            return (
                <tr style={{ backgroundColor: '#eeeeee !important' }} className={'error-result-import ' + (getTypeError[e['ResultType']] !== "FATAL" ? "file-import-aborted-warning" : "")} key={i}>
                    <td className="col-te">{getTypeError[e['ResultType']]}</td>
                    <td className="col-line">Line: {e.ErrorLine}</td>
                    <td className="col-col">{e.ErrorColumn}</td>
                    <td className="col-mess">{e.ErrorDetail}</td>
                </tr>
            )
        })
    }

    getClassName = i => {
        return i%2 !==0 ? 'empty-row empty-row-odd' : 'empty-row'
    }

    render() {
        const { dataImport } = this.props
        const { faltal } = dataImport

        return (
            <div id='step3'>
                <div className='contain-table'>
                    <table>
                        <thead>
                            <tr className='title'>
                                <th className={'item1' + (faltal ? " occur-faltal" : '')} colSpan={5}>{!faltal ? lang.title_table_file_import_success : lang.title_table_file_import_aborted}</th>
                                <th className='item2' colSpan={2}>Errors</th>
                            </tr>
                            <tr>
                                <th>Import Date Time</th>
                                <th>Channel</th>
                                <th>Items Added</th>
                                <th>Items Updated</th>
                                <th>Items Deleted</th>
                                <th>Error Count</th>
                            </tr>
                        </thead>
                        <tbody className={faltal ? "tbody-occur-faltal" : ''}>
                            {this.renderRow()}
                            {dataImport.importResultDetails.length > 0 && (
                                <tr>
                                    <td colSpan={7} className='childen-table-import-result'>
                                        <table className="tbl-fix tbl-grey tbl-import-warn">
                                            <tbody>
                                                <tr>
                                                    <td colSpan={4}>
                                                        <span className="error-description">Fatal Error Occurred. Importing all data has been canceled.</span>
                                                    </td>
                                                </tr>
                                                {this.renderRowChildren()}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default Step3



// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/import-panel/step3/index.js